<div *ngFor="let field of fields" >
  <app-modellfelt [formGroup]="formGroup" [field]="field" [modell]="modell" [initialModell]="initialModell"></app-modellfelt>
</div>

